import React from 'react';
import EditIcon from '@mui/icons-material/Edit';
import SyncIcon from '@mui/icons-material/Sync';
import PowerSettingsNew from '@mui/icons-material/PowerSettingsNew';
import { theme } from 'utils/theme';
import { isActive } from 'utils/misc';
import { IconButtonWithTooltip } from 'components/IconButtonWithTooltip';

export const renderEditButton = (params, setEmployeeId, setIsEmployeeModalOpen) => {
    const handleEditClick = () => {
        setEmployeeId(params.row.id);
        setIsEmployeeModalOpen(true);
    };

    if (isActive(params.row)) {
        return (
            <IconButtonWithTooltip
                onClick={handleEditClick}
                icon={<EditIcon />}
                tooltipText="Edit"
                color={theme.palette.primary.main}
            />
        );
    } else {
        return null;
    }
};

export const renderDeleteReactivateButton = (
    params,
    setEmployeeId,
    setIsDeleteEmployeeModalOpen,
    setIsReactivateEmployeeModalOpen
) => {
    const handleDeleteClick = () => {
        setEmployeeId(params.row.id);
        setIsDeleteEmployeeModalOpen(true);
    };

    const handleReactivateClick = () => {
        setEmployeeId(params.row.id);
        setIsReactivateEmployeeModalOpen(true);
    };

    return (
        <div>
            {isActive(params.row) ? (
                <IconButtonWithTooltip
                    onClick={handleDeleteClick}
                    icon={<PowerSettingsNew />}
                    tooltipText="Deactivate"
                    color={theme.palette.redColor.main}
                />
            ) : (
                <IconButtonWithTooltip
                    onClick={handleReactivateClick}
                    icon={<SyncIcon />}
                    tooltipText="Reactivate"
                    color={theme.palette.primary.main}
                />
            )}
        </div>
    );
};

export const employeeColumns = [
    { field: 'id', headerName: 'ID' },
    {
        field: 'firstName',
        headerName: 'First Name',
        flex: 0.3,
        minWidth: 50,
    },
    { field: 'lastName', headerName: 'Last Name', flex: 0.3, minWidth: 50 },
    { field: 'email', headerName: 'Email', flex: 0.3, minWidth: 50 },
    { field: 'pxCode', headerName: 'PX Code', flex: 0.3, minWidth: 15 },
    { field: 'category', headerName: 'Category', flex: 0.3, minWidth: 50 },
    { field: 'workingPlace', headerName: 'Working Place', flex: 0.3, minWidth: 50 },
    { field: 'roles', headerName: 'Roles', flex: 0.3, minWidth: 50 },
    {
        field: 'active',
        type: 'boolean',
        headerName: 'Active',
    },
    {
        field: 'edit',
        headerName: '',
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        width: 120,
        renderCell: renderEditButton,
    },
    {
        field: 'delete-reactivate',
        headerName: '',
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        width: 120,
        renderCell: renderDeleteReactivateButton,
    },
];
